var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"arrow-link",class:{
    'arrow-link--left': _vm.direction === 'left',
    'arrow-link--right': _vm.direction === 'right'
  },attrs:{"href":_vm.tag === 'a' ? _vm.href : false}},[(_vm.direction === 'left')?[_c('inline-svg',{attrs:{"src":"arrow-left"}})]:_vm._e(),_c('span',{class:_vm.textClass},[_vm._t("default")],2),(_vm.direction === 'right')?[_c('inline-svg',{attrs:{"src":"arrow-right"}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }